import api from '@api';
import { withArchive } from 'src/resources/withArchive';
import { call, put, takeEvery } from 'redux-saga/effects';
import { TransportsListResType } from 'src/types/transportsList';
import { getTransportsListFetchSuccess, getTransportsListFetchFailure } from './reducer';

const getTransportsListFetchRequest = async (archive?: boolean) => {
    const res = await api('get', withArchive('api/secure/transports', archive));
    return res.data.data;
};

function* getTransportsListFetch(action: { type: string; payload?: { archive?: boolean } }) {
    try {
        const response: TransportsListResType = yield call((): any => getTransportsListFetchRequest(action.payload?.archive));
        yield put(getTransportsListFetchSuccess(response));
    } catch (error) {
        yield put(getTransportsListFetchFailure({ error }));
    }
}

export function* getTransportsListFetchWatch() {
    yield takeEvery('transportsList/getTransportsListFetch', getTransportsListFetch);
}
